// extracted by mini-css-extract-plugin
export var equalColumn = "_fa-0";